import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { TextareaAutosize } from '@material-ui/core';



export default function Step10() {

  return (
    <>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={12}>
            <TextareaAutosize style={{width:"100%", height:"100%"}} id="anyadditionalinformation" placeholder={"Type here....."}   fullWidth/>
        </Grid>
      </Grid>

     
      


</>
    
  );

}
